module.exports = "/_next/static/videos/mainvisual-video-M-6b8188c982bc2c56c6e40f3be90d4bc1.mp4";